import { makeStyles, tokens } from "@fluentui/react-components";

export const useFREStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: tokens.spacingVerticalL,
  },
  header: {
    marginTop: tokens.spacingVerticalXXXL,
    marginBottom: tokens.spacingVerticalXXXL,
  },
  featuresContainer: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
  },
  featureContainer: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    "& span": {
      fontWeight: tokens.fontWeightBold,
    },
  },
  button: {
    marginTop: tokens.spacingVerticalL,
    position: "relative",
  },
});
